import { createContext, useCallback, useReducer } from "react";
import DriverReducer from "./DriverReducer";
import { getDrivers } from "./apiCalls"; // use your actual API file path

const INITIAL_STATE = {
    drivers: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const DriverContext = createContext(INITIAL_STATE);

export const DriverContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(DriverReducer, INITIAL_STATE);

    const fetchDrivers = useCallback(
        async (toast, forceRefresh = false) => {
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getDrivers(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <DriverContext.Provider
            value={{
                drivers: state.drivers,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchDrivers,
            }}
        >
            {children}
        </DriverContext.Provider>
    );
};